<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        :viewBox="'0 0 ' + icon[0] + ' ' + icon[1]"
        width="1em"
        height="1em"
        fill="currentColor"
        aria-hidden="true"
    >
        <path :d="icon[4]"></path>
    </svg>
</template>

<script>
// Replacement for vue-awesome's <icon>: renders a FontAwesome 5 free solid icon
// inline. Path data comes from the icon package so it stays correct.
import { faUser, faKey, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'

const ICONS = {
    user: faUser,
    key: faKey,
    eye: faEye,
    'eye-slash': faEyeSlash,
}

export default {
    props: {
        name: {
            type: String,
            required: true,
        },
    },

    computed: {
        icon () {
            // IconDefinition: { prefix, iconName, icon: [width, height, ligatures, unicode, svgPathData] }
            const def = ICONS[this.name] || faUser
            return def.icon
        },
    },
}
</script>